import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { colors } from '@guryou/colors';
import { Block, ContainedButton, FlexRow, Form, LargeText, TextBox } from '@guryou/html-components';
import { Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import clsx from 'clsx';
import ModernDropdown from '../components/ModernDropdown';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 50px)',
    marginTop: '50px',
    padding: theme.spacing(3),
    backgroundColor: '#212121',
    color: 'white',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));

const WorkoutFormView = ({ open }) => {
  const classes = useStyles();
  const history = useHistory();
  const [level, setLevel] = useState('all_levels');

  const levelOptions = [
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'expert', label: 'Expert' },
    { value: 'athlete', label: 'Athlete' },
    { value: 'all_levels', label: 'All Levels' },
  ];

  const handleSubmit = async data => {
    try {
      const input = {
        title: data.title,
        description: data.description || '',
        price: data.price ? parseFloat(data.price) : 0,
        level: level,
        provider_id: 260,
        active: true,
        archive: false,
      };

      const query = `
          mutation CreateWorkout($input: WorkoutInput!) {
            createWorkout(input: $input) {
              id
              title
              description
            }
          }
        `;
      const variables = {
        input,
      };

      const response = await fetch('https://1ccbrgd0eh.execute-api.eu-west-1.amazonaws.com/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query,
          variables,
        }),
      });

      const result = await response.json();

      if (result.errors) {
        alert(`Error creating workout. Please try again.`);
      } else {
        history.push('/guryou-ai-studio/workouts');
      }
    } catch (error) {
      alert(`Error creating workout. Please try again.`);
    }
  };

  return (
    <main
      className={clsx(classes.content, {
        [classes.contentShift]: open,
      })}
    >
      <Box style={{ overflowY: 'auto', flex: 1 }}>
        <IconButton onClick={() => history.goBack()} style={{ marginBottom: '16px' }}>
          <ChevronLeftIcon style={{ color: 'white' }} />
        </IconButton>

        <LargeText fontWeight="700" width="fit-content" margin="0 auto" marginBottom={10} color={colors.white}>
          Create Workout
        </LargeText>

        <Form actions={false} onSubmit={handleSubmit} parserVersion={2}>
          <FlexRow alignItems="flex-start" style={{ marginBottom: '40px' }}>
            <div style={{ flex: 1, marginRight: '8px' }}>
              <TextBox
                name="title"
                label="Title"
                required={true}
                InputLabelProps={{ style: { color: 'white' } }}
                inputProps={{ style: { color: 'white' } }}
              />
            </div>
            <div style={{ flex: 1, marginLeft: '8px' }}>
              <TextBox
                name="description"
                label="Description"
                InputLabelProps={{ style: { color: 'white' } }}
                inputProps={{ style: { color: 'white' } }}
              />
            </div>
          </FlexRow>

          <FlexRow alignItems="center" style={{ marginBottom: '40px' }}>
            <div style={{ flex: 1, marginRight: '8px' }}>
              <TextBox
                name="price"
                label="Price"
                type="number"
                InputLabelProps={{ style: { color: 'white' } }}
                inputProps={{ style: { color: 'white' } }}
              />
            </div>
            <div style={{ flex: 1, marginLeft: '8px' }}>
              <ModernDropdown label="Level" options={levelOptions} value={level} onChange={setLevel} />
            </div>
          </FlexRow>

          <Block textAlign="center" marginTop={4} marginBottom={4}>
            <ContainedButton type="submit" text="Create" />
          </Block>
        </Form>
      </Box>
    </main>
  );
};

export default WorkoutFormView;
